import React from 'react';
import Multiselect from '@amzn/awsui-components-core/multiselect';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { studioDeckOptions } from 'src/components/star-grid/utils/studioDeckOptions';
import styles from 'src/components/star-grid/components/styles/StudioHeader.module.scss';
interface Props {
  readonly state: Pick<ReportStudioState, 'text' | 'draft' | 'template' | 'includeDecks'>;
}

/**
 * Which decks the report contains, as ONE multiselect.
 *
 * Was a chip list plus a "Manage decks" modal: two controls and a round trip to add a deck, and the
 * chips could not show what was NOT selected. A multiselect is the same choice in one place.
 *
 * At least one deck must stay selected -- a report with no deck has no columns or rows -- so clearing
 * the last one is ignored rather than offered and then rejected on save.
 */
export const StudioDeckSettings: React.FC<Props> = ({ state }) => {
  const options = studioDeckOptions(state.template.catalog, state.draft.definition).map((deck) => ({ value: deck.id, label: deck.label }));
  const selected = state.draft.definition.deck_types.map((deck) => ({ value: deck, label: deck }));
  return (
    <label className={`${styles.field} ${styles.picker}`} aria-label={state.text('studioApplicableDecks')}>
      <span className={styles.fieldLabel}>{state.text('studioApplicableDecks')}</span>
      <Multiselect
        selectedOptions={selected}
        options={options}
        expandToViewport
        hideTokens
        placeholder={state.text('studioDecksPlaceholder')}
        ariaLabel={state.text('studioApplicableDecks')}
        data-testid="studio-included-decks"
        onChange={({ detail }) => {
          const next = detail.selectedOptions.map((option) => String(option.value));
          if (next.length) state.includeDecks(next);
        }}
      />
    </label>
  );
};
